/* Popup engine for sections/ASRJ-main-interactive-popup.liquid.
   Rules are rendered by Liquid into window.AsrjPopupRules in the section; this file is loaded with defer. */
(function() {
    // A. Track Session, Visits & UTMs immediately
    function updateSessionData() {
      let visits = parseInt(localStorage.getItem('popup_visit_count') || '0');
      if (!sessionStorage.getItem('popup_session_active')) {
        visits += 1;
        localStorage.setItem('popup_visit_count', visits);
        sessionStorage.setItem('popup_session_active', 'true');
      }

      const urlParams = new URLSearchParams(window.location.search);
      
      // FIX 1: Clean up old buggy localStorage data so it doesn't haunt you or returning users
      localStorage.removeItem('popup_saved_utms');
      
      // FIX 2: Use sessionStorage so UTM targeting resets naturally for new visits
      let savedUtms = JSON.parse(sessionStorage.getItem('popup_session_utms') || '[]');
      
      for (const [key, value] of urlParams.entries()) {
        if (key.toLowerCase().startsWith('utm_')) {
          const valLower = value.toLowerCase();
          // FIX 3: Compare against the lowercased value to prevent duplicate array entries
          if (!savedUtms.includes(valLower)) {
            savedUtms.push(valLower);
          }
        }
      }
      sessionStorage.setItem('popup_session_utms', JSON.stringify(savedUtms));
      
      return { visits, savedUtms };
    }

    const { visits, savedUtms } = updateSessionData();
    const isMobile = window.innerWidth <= 768;

    // B. Configuration rendered by Liquid in the section (see ASRJ-main-interactive-popup.liquid)
    const popupRules = Array.isArray(window.AsrjPopupRules) ? window.AsrjPopupRules : [];

    class PopupController {
      constructor(rules) {
        this.rules = rules;
        this.storageKey = 'popup_user_state'; 
        this.state = JSON.parse(localStorage.getItem(this.storageKey)) || { converted: false, minimized: false, minimizedVariant: null };
        
        // Check if the popup was closed within the last 24 hours
        const closedTime = localStorage.getItem('popup_closed_timestamp');
        this.isClosedFor24h = false;

        if (closedTime) {
          const hoursPassed = (Date.now() - parseInt(closedTime)) / (1000 * 60 * 60);
          if (hoursPassed < 24) {
            this.isClosedFor24h = true; // Still within the 24h window
          } else {
            localStorage.removeItem('popup_closed_timestamp'); // 24h passed, clear it
          }
        }
        this.klaviyoReady = false;
        
        this.close = this.close.bind(this);
        this.success = this.success.bind(this);
        this.minimize = this.minimize.bind(this);

        this.init();
      }

      init() {
        // Stop execution if converted OR if they closed it within the last 24 hours
        if (this.state.converted || this.isClosedFor24h) return;

        // The 10s timer starts when the visitor clicks the cookie banner
        // (Accept, Decline, or saved preferences). Where Shopify shows no banner,
        // it starts on load.
        this.whenConsentSettled(() => {
          if (this.state.minimized && this.state.minimizedVariant) {
            const isCollectionPage = window.location.pathname.includes('/collections');
            if (isCollectionPage) {
              this.injectVariant(this.state.minimizedVariant, true);
            }
            return;
          }

          this.waitForKlaviyo(() => this.evaluateRules());
        });
      }

      bannerIsOpen() {
        const banner = document.getElementById('shopify-pc__banner');
        if (!banner) return false;
        const style = window.getComputedStyle(banner);
        if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
        const rect = banner.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
      }

      consentIsSettled() {
        if (this.bannerIsOpen()) return false;
        const privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return false;
        // shouldShowBanner() stays true after a choice on this store. A yes/no
        // on any purpose means the visitor has decided. No banner (Switzerland)
        // is shouldShowBanner() === false with an empty choice.
        if (typeof privacy.shouldShowBanner === 'function' && privacy.shouldShowBanner()) {
          const consent = privacy.currentVisitorConsent() || {};
          return ['marketing', 'analytics', 'preferences'].some((key) => consent[key] === 'yes' || consent[key] === 'no');
        }
        return true;
      }

      whenConsentSettled(callback) {
        let finished = false;
        let observer = null;
        const finish = () => {
          if (finished || !this.consentIsSettled()) return;
          finished = true;
          if (observer) observer.disconnect();
          callback();
        };
        const watch = () => {
          finish();
          if (finished) return;
          observer = new MutationObserver(finish);
          observer.observe(document.documentElement, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class', 'hidden']
          });
          document.addEventListener('visitorConsentCollected', () => {
            requestAnimationFrame(() => requestAnimationFrame(finish));
          });
        };
        const boot = (attempts) => {
          const shopify = window.Shopify;
          if (shopify && shopify.customerPrivacy) {
            watch();
            return;
          }
          if (shopify && shopify.loadFeatures) {
            shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function () {
              watch();
            });
            return;
          }
          if (attempts > 80) return;
          setTimeout(() => boot(attempts + 1), 50);
        };
        boot(0);
      }

      waitForKlaviyo(cb) {
        if (typeof klaviyo !== 'undefined') { this.klaviyoReady = true; cb(); }
        else {
          let attempts = 0;
          let int = setInterval(() => {
            if (typeof klaviyo !== 'undefined' || ++attempts > 15) {
              clearInterval(int);
              if (typeof klaviyo !== 'undefined') this.klaviyoReady = true;
              cb();
            }
          }, 200);
        }
      }

      evaluateRules() {
        for (const rule of this.rules) {
          if (this.isEligibleForRule(rule)) {
            this.executeRule(rule);
            break; 
          }
        }
      }

      isEligibleForRule(rule) {
        // 1. Visit Check
        if (rule.targetVisit !== 0 && rule.targetVisit !== visits) return false;
        
        // 2. Block by Excluded URL (NEW)
        if (rule.excludeUrl && rule.excludeUrl.trim() !== '') {
          const currentUrl = window.location.href.toLowerCase();
          if (currentUrl.includes(rule.excludeUrl)) return false;
        }

        // 3. Require Specific UTM Check
        if (rule.requiredUtm && rule.requiredUtm.trim() !== '') {
          const hasUtm = savedUtms.some(utm => utm.includes(rule.requiredUtm));
          if (!hasUtm) return false;
        }

        // 4. Klaviyo Existing Profile Check
        const isKnown = (typeof klaviyo !== 'undefined' && klaviyo.isIdentified && klaviyo.isIdentified()) || 
                        (typeof _learnq !== 'undefined' && _learnq.isIdentified && _learnq.isIdentified());
        if (!rule.showToExisting && isKnown) return false;

        // 5. Missing Variants Check
        const variants = isMobile ? rule.mobileVariants : rule.desktopVariants;
        if (variants.length === 0) return false;

        return true;
      }

      executeRule(rule) {
        const variants = isMobile ? rule.mobileVariants : rule.desktopVariants;
        
        let chosenVariant = sessionStorage.getItem(`ab_variant_${rule.id}`);
        if (!chosenVariant) {
          chosenVariant = variants[Math.floor(Math.random() * variants.length)];
          sessionStorage.setItem(`ab_variant_${rule.id}`, chosenVariant);
        }

        const show = () => this.injectVariant(chosenVariant, false);

        // whenConsentSettled already ran, so this clock starts at the banner click.
        if (rule.scroll > 0) {
          const onScroll = () => {
            const screensScrolled = window.scrollY / window.innerHeight;

            if (screensScrolled >= rule.scroll) {
              window.removeEventListener('scroll', onScroll);
              show();
            }
          };
          window.addEventListener('scroll', onScroll);
        } else if (rule.delay > 0) {
          setTimeout(show, rule.delay * 1000);
        } else {
          show();
        }
      }

      injectVariant(variantName, isMinimizedMode) {
        if (this.bannerIsOpen()) return;
        const template = document.getElementById(`template-${variantName}`);
        if (!template) {
          console.warn(`Popup variant ${variantName} not found in registry.`);
          return;
        }

        const clone = template.content.cloneNode(true);
        const wrapper = clone.querySelector('.custom-popup-wrapper');
        
        if (isMinimizedMode) {
          wrapper.classList.add('is-minimized');
        }

        document.body.appendChild(clone);

        if (!isMinimizedMode) {
          document.body.style.overflow = 'hidden';

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "custom_popup_viewed",
            popup_variant: variantName
          });

          if (this.klaviyoReady) {
            klaviyo.track("Viewed Custom Pop-up", { Variant: variantName });
          }
        }
      }

      close() {
        document.querySelector('.custom-popup-wrapper')?.remove();
        document.body.style.overflow = '';
        localStorage.setItem('popup_closed_timestamp', Date.now().toString());
        this.isClosedFor24h = true;
      }

      minimize(variantName) {
        this.state.minimized = true;
        this.state.minimizedVariant = variantName;
        localStorage.setItem(this.storageKey, JSON.stringify(this.state));
        
        document.querySelector('.custom-popup-wrapper')?.classList.add('is-minimized');
        document.body.style.overflow = '';
      }

      success() {
        this.state.converted = true;
        this.state.minimized = false; 
        localStorage.setItem(this.storageKey, JSON.stringify(this.state));

        const activeWrapper = document.querySelector('.custom-popup-wrapper');
        const activeVariant = activeWrapper ? activeWrapper.getAttribute('data-variant') : 'unknown';

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "custom_popup_submitted",
          popup_variant: activeVariant
        });
      }
    } 

    const engine = new PopupController(popupRules);
    window.CustomPopup = {
      close: engine.close,
      minimize: engine.minimize,
      success: engine.success
    };

})();
